
<section class="mx-6 md:mx-20 lg:mx-40 min-h-screen pb-20">
    <div class="fixed bottom-3 right-5 flex justify-end px-2 pt-0 pb-5 z-20">
        <button (click)="openCreateModal()" type="button" class="rounded-full bg-orange-600 p-2 text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600">
            <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
              <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
            </svg>
        </button>
    </div>
    <div class="text-center mb-6">
      <button 
        (click)="onTopicsClick()" 
        class="inline-flex gap-2 bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition duration-150 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 text-sm font-medium shadow-sm">
        <svg class="mr-1 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>      
        Topics Analysis
        <span *ngIf="hasActiveTopicFilter" class="ml-1 bg-red-800 text-xs px-2 py-0.5 rounded-full font-semibold">
          ({{ targetTopicsCollections.length }})
        </span>
      </button>
    </div>

    <!-- Barra de Filtros y Configuración -->
    <div class="mb-6 p-4 bg-white rounded-lg shadow-sm border border-gray-200">
      <div class="grid grid-cols-1 md:grid-cols-8 gap-3 items-end">
        <!-- Búsqueda por nombre / Lista de nombres -->
        <div class="md:col-span-8">
          <label class="block text-xs font-medium text-gray-700 mb-1">Buscar por nombre o lista (separados por comas)</label>
          <div class="relative rounded-md shadow-sm">
            <input 
              type="text" 
              [(ngModel)]="searchTerm" 
              (keyup.enter)="applyFilters()"
              placeholder="Ej: col_a, col_b o nombre parcial..." 
              class="block w-full rounded-md border-gray-300 pr-8 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm px-3 py-2 border">
            <button 
              *ngIf="searchTerm" 
              (click)="clearSearch()" 
              class="absolute inset-y-0 right-0 pr-2.5 flex items-center text-gray-400 hover:text-gray-600">
              <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Límite de Colecciones -->
        <div class="md:col-span-2">
          <label class="block text-xs font-medium text-gray-700 mb-1">Límite (vacío = todas)</label>
          <input 
            type="number" 
            [(ngModel)]="collectionLimit" 
            (keyup.enter)="applyFilters()"
            placeholder="Todas" 
            min="1" 
            class="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm px-3 py-2 border">
        </div>

        <!-- Fecha Inicio -->
        <div class="md:col-span-2">
          <label class="block text-xs font-medium text-gray-700 mb-1">Fecha inicio</label>
          <input 
            type="date" 
            [(ngModel)]="filterStartDate" 
            class="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm px-2 py-2 border">
        </div>

        <!-- Fecha Fin -->
        <div class="md:col-span-2">
          <label class="block text-xs font-medium text-gray-700 mb-1">Fecha fin</label>
          <input 
            type="date" 
            [(ngModel)]="filterEndDate" 
            class="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm px-2 py-2 border">
        </div>

        <!-- Botones Aplicar y Limpiar -->
        <div class="md:col-span-2 flex items-center gap-2">
          <button 
            (click)="applyFilters()" 
            type="button"
            class="flex-1 inline-flex justify-center items-center px-3 py-2 border border-transparent shadow-sm text-xs font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <svg class="h-3.5 w-3.5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
            </svg>
            Aplicar
          </button>
          <button 
            (click)="clearAllFilters()" 
            title="Limpiar filtros"
            type="button"
            class="inline-flex justify-center items-center px-3 py-2 border border-gray-300 shadow-sm text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
            Limpiar
          </button>
        </div>
      </div>

      <!-- Barra de Estado de Filtros -->
      <div class="mt-3 pt-3 border-t border-gray-100 flex flex-wrap items-center justify-between text-xs text-gray-500">
        <div>
          <ng-container *ngIf="appliedCollectionLimit && appliedCollectionLimit > 0">
            Mostrando <span class="font-semibold text-gray-800">{{ displayedCollections.length }}</span> colecciones
            <span class="ml-1 text-indigo-600 font-medium">(Página {{ currentPage }})</span>
          </ng-container>
          <ng-container *ngIf="!appliedCollectionLimit || appliedCollectionLimit <= 0">
            Mostrando <span class="font-semibold text-gray-800">{{ displayedCollections.length }}</span> colecciones
            <span *ngIf="collectionCount !== null" class="font-medium"> (total: {{ collectionCount }})</span>
          </ng-container>
        </div>
        <div *ngIf="appliedCollectionLimit && appliedCollectionLimit > 0" class="text-indigo-600 font-medium">
          Página {{ currentPage }}
        </div>
      </div>
    </div>

    <!-- Lista de Colecciones -->
    <ul role="list" class="divide-y divide-gray-100">
       <div *ngFor="let collection of displayedCollections"> 
            <li class="flex items-center justify-between gap-x-6 py-4" >
                <div class="min-w-0 flex-1">
                  <div class="flex items-center gap-x-2.5">
                      <p (click)="openInfo(collection)" class="text-sm font-semibold text-gray-900 hover:cursor-pointer hover:text-indigo-600 transition-colors">{{collection.name}}</p>
                      <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                        {{ collection.elements }} {{ collection.elements === 1 ? 'documento' : 'documentos' }}
                      </span>
                  </div>
                  <div class="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-500">
                      <span *ngIf="collection.created_at" class="inline-flex items-center text-gray-500">
                        <span class="text-gray-400 mr-1">Creada:</span> {{formatDate(collection.created_at)}}
                      </span>
                      <span *ngIf="collection.updated" class="inline-flex items-center text-gray-500">
                        <span class="text-gray-400 mr-1">Modificada:</span> {{formatDate(collection.updated)}}
                      </span>
                  </div>
                </div>
                <div class="flex flex-none items-center gap-x-4">
                <a (click)="openCollection(collection.name)"  class="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:cursor-pointer hover:bg-gray-100 sm:block">Ver documentos<span class="sr-only"></span></a>
                <div class="relative flex-none">
                    <button (click)="openDropdown(collection)"  type="button" class="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900" id="options-menu-1-button" aria-expanded="false" aria-haspopup="true">
                    <span class="sr-only">Open options</span>
                    <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                        <path d="M10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM10 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM11.5 15.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
                    </svg>
                    </button>
            
                    <div *ngIf="collection.dropdown" class="absolute right-0 z-10 mt-2 w-44 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="options-menu-1-button" tabindex="-1">
                    <a (click)="openTopicsForCollection(collection)" class="block px-3 py-1 text-sm text-gray-900 hover:cursor-pointer hover:bg-yellow-100" role="menuitem" tabindex="-1">Topics<span class="sr-only"></span></a>
                    <a (click)="openModal(collection,'search')" class="block px-3 py-1 text-sm text-gray-900 hover:cursor-pointer hover:bg-blue-100" role="menuitem" tabindex="-1">Search<span class="sr-only"></span></a>
                    <a (click)="openModal(collection,'edit')" class="block px-3 py-1 text-sm text-gray-900 hover:cursor-pointer hover:bg-green-100" role="menuitem" tabindex="-1">Edit<span class="sr-only"></span></a>
                    <a (click)="openModal(collection,'delete')" class="block px-3 py-1 text-sm text-gray-900 hover:cursor-pointer hover:bg-red-100" role="menuitem" tabindex="-1">Delete<span class="sr-only"></span></a>
                    <a (click)="syncCollectionCount(collection)" class="block px-3 py-1 text-sm text-gray-900 hover:cursor-pointer hover:bg-indigo-50" role="menuitem" tabindex="-1">Count documents<span class="sr-only"></span></a>
                    </div>
                </div>
                </div>
            </li> 
            <div *ngIf="collection.info" class="bg-gray-50 border border-gray-200 rounded-xl shadow-md p-2 my-2">
                <dl class="divide-y divide-gray-200">
                  <div class="px-2 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt class="pl-3 text-sm font-medium text-black">Función de Embbedings</dt>
                      <dd class="mt-1 text-sm text-gray-800 sm:col-span-2 sm:mt-0">{{collection.embedding_function}}</dd>
                  </div>
                  <div class="px-2 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt class="pl-3 text-sm font-medium text-black">Función de comparación</dt>
                      <dd class="mt-1 text-sm text-gray-800 sm:col-span-2 sm:mt-0">{{collection.distance}}</dd>
                  </div>
                  <div class="px-2 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt class="pl-3 text-sm font-medium text-black">Número de elementos</dt>
                      <dd class="mt-1 text-sm text-gray-800 sm:col-span-2 sm:mt-0">{{collection.elements}}</dd>
                  </div>
                  <div *ngIf="collection.created_at" class="px-2 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt class="pl-3 text-sm font-medium text-black">Fecha de creación</dt>
                      <dd class="mt-1 text-sm text-gray-800 sm:col-span-2 sm:mt-0">{{formatDate(collection.created_at)}}</dd>
                  </div>
                  <div *ngIf="collection.updated" class="px-2 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt class="pl-3 text-sm font-medium text-black">Última modificación</dt>
                      <dd class="mt-1 text-sm text-gray-800 sm:col-span-2 sm:mt-0">{{formatDate(collection.updated)}}</dd>
                  </div>
                  <div *ngIf="getCustomMetadata(collection).length > 0" class="px-2 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt class="pl-3 text-sm font-medium text-black">Metadatos</dt>
                      <dd class="mt-1 text-sm text-gray-800 sm:col-span-2 sm:mt-0 space-y-1">
                        <div *ngFor="let meta of getCustomMetadata(collection)" class="text-xs">
                          <span class="font-medium text-gray-700 bg-gray-200 px-1.5 py-0.5 rounded">{{ meta.key }}:</span> {{ meta.value }}
                        </div>
                      </dd>
                  </div>
                </dl>
            </div>
        </div>
        
        <div *ngIf="isLoading" class="py-12 text-center text-indigo-600 font-medium">
          Cargando colecciones...
        </div>
        <div *ngIf="!isLoading && displayedCollections.length === 0" class="py-12 text-center text-gray-500">
          No se encontraron colecciones con los filtros especificados.
        </div>
    </ul>

    <!-- Paginación -->
    <div *ngIf="isPaginated" class="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 rounded-lg mt-4 shadow-sm">
      <div class="flex flex-1 justify-between sm:hidden">
        <button (click)="prevPage()" [disabled]="currentPage === 1 || isLoading" class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50">Anterior</button>
        <button (click)="nextPage()" [disabled]="!hasMoreCollections || isLoading" class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50">Siguiente</button>
      </div>
      <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p class="text-sm text-gray-700">
            Página <span class="font-medium">{{ currentPage }}</span>
          </p>
        </div>
        <div>
          <nav class="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
            <button (click)="prevPage()" [disabled]="currentPage === 1 || isLoading" class="relative inline-flex items-center rounded-l-md px-3 py-2 text-gray-500 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 disabled:opacity-50">
              Anterior
            </button>
            <button (click)="nextPage()" [disabled]="!hasMoreCollections || isLoading" class="relative inline-flex items-center rounded-r-md px-3 py-2 text-gray-500 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 disabled:opacity-50">
              Siguiente
            </button>
          </nav>
        </div>
      </div>
    </div>
</section>



<!-- Delete modal -->
<section>
    <div *ngIf="delete_modal.visible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <!--
          Background backdrop, show/hide based on modal state.
      
          Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>
      
        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <!--
              Modal panel, show/hide based on modal state.
      
              Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                To: "opacity-100 translate-y-0 sm:scale-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 sm:scale-100"
                To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            -->
            <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
              <div class="sm:flex sm:items-start">
                <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                  <svg class="size-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                  </svg>
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold text-gray-900" id="modal-title"></h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">{{delete_modal.title}}</p>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button (click)="deleteCollection(delete_modal.collection)" type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Eliminar</button>
                <button (click)="delete_modal.visible = !delete_modal.visible" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
</section>


<!-- Edit modal -->
<section>
    <div *ngIf="edit_modal.visible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <!--
          Background backdrop, show/hide based on modal state.
      
          Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>
      
        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <!--
              Modal panel, show/hide based on modal state.
      
              Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                To: "opacity-100 translate-y-0 sm:scale-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 sm:scale-100"
                To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            -->
            <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
              <div class="sm:flex sm:items-start">
                <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                  <svg class="size-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                  </svg>
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold text-gray-900" id="modal-title"></h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">{{edit_modal.title}}</p>
                  </div>
                </div>
              </div>
              <div class="relative mt-8">
                <label for="name" class="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Nombre</label>
                <input type="text" name="name" id="name" [(ngModel)]="edit_modal.newName" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="Nuevo nombre">
              </div>

              <!-- Metadatos de Sistema (Solo lectura) -->
              <div *ngIf="edit_modal.systemInfo" class="mt-4 bg-gray-50 rounded-md p-3 text-xs text-gray-600 space-y-1 border border-gray-200">
                <div *ngIf="edit_modal.systemInfo.distance">
                  <span class="font-medium text-gray-700">Distancia:</span> {{ edit_modal.systemInfo.distance }}
                </div>
                <div *ngIf="edit_modal.systemInfo.embedding_function">
                  <span class="font-medium text-gray-700">Embedding:</span> {{ edit_modal.systemInfo.embedding_function }}
                </div>
                <div *ngIf="edit_modal.systemInfo.created_at">
                  <span class="font-medium text-gray-700">Creada:</span> {{ formatDate(edit_modal.systemInfo.created_at) }}
                </div>
                <div *ngIf="edit_modal.systemInfo.updated">
                  <span class="font-medium text-gray-700">Última actualización:</span> {{ formatDate(edit_modal.systemInfo.updated) }}
                </div>
              </div>

              <!-- Metadatos Personalizados Editables -->
              <div class="mt-6 border-t border-gray-200 pt-4">
                <div class="flex items-center justify-between mb-3">
                  <span class="text-xs font-semibold text-gray-700 uppercase tracking-wider">Metadatos personalizados</span>
                  <button 
                    (click)="addEditMetadata()" 
                    type="button" 
                    class="inline-flex items-center text-xs font-medium text-orange-600 hover:text-orange-700">
                    <svg class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                    </svg>
                    Añadir metadato
                  </button>
                </div>

                <div *ngIf="edit_modal.metadata.length === 0" class="text-xs text-gray-400 italic py-1">
                  Sin metadatos adicionales definidos.
                </div>

                <div *ngFor="let item of edit_modal.metadata; let i = index" class="flex items-center gap-2 mb-2">
                  <input 
                    type="text" 
                    [(ngModel)]="item.key" 
                    placeholder="Clave (ej. description)" 
                    class="block w-1/2 rounded-md bg-white px-2.5 py-1.5 text-xs text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:outline-orange-600">
                  <input 
                    type="text" 
                    [(ngModel)]="item.value" 
                    placeholder="Valor" 
                    class="block w-1/2 rounded-md bg-white px-2.5 py-1.5 text-xs text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:outline-orange-600">
                  <button 
                    (click)="removeEditMetadata(i)" 
                    type="button" 
                    class="text-gray-400 hover:text-red-500 p-1" 
                    title="Eliminar metadato">
                    <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </div>
              
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button (click)="editCollection(edit_modal.collection,edit_modal.newName)" type="button" class="inline-flex w-full justify-center rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto">Guardar</button>
                <button (click)="edit_modal.visible = !edit_modal.visible" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
</section>

<!-- Create modal -->
<section>
    <div *ngIf="create_modal" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <!--
          Background backdrop, show/hide based on modal state.
      
          Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>
      
        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <!--
              Modal panel, show/hide based on modal state.
      
              Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                To: "opacity-100 translate-y-0 sm:scale-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 sm:scale-100"
                To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            -->
            <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
              <div class="sm:flex sm:items-start">
                <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:size-10">
                  <svg class="size-5 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 16 16" c aria-hidden="true" data-slot="icon">
                    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z"/>
                    <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4"/>
                  </svg>
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold text-gray-900" id="modal-title"></h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">Creación de nueva Colección</p>
                  </div>
                </div>
              </div>
              <div class="relative mt-8">
                <label for="create_name" class="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Nombre</label>
                <input type="text" name="create_name" id="create_name" [(ngModel)]="newCollection_name" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="Nuevo nombre">
              </div>
              <div class="relative mt-8">
                <label for="create_distance" class="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Tipo de comparación</label>
                <select name="create_distance" id="create_distance" [(ngModel)]="selected_distance" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6">
                    <option *ngFor="let element of distance_models" [value]="element.value">{{element.name}}</option>
                </select>
              </div>
              <div class="relative mt-8">
                <label for="create_function" class="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Embedding Function</label>
                <select name="create_function" id="create_function" [(ngModel)]="selected_function" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6">
                    <option *ngFor="let element of embedding_functions" [value]="element.value">{{element.name}}</option>
                </select>              
              </div>

              <!-- Metadatos personalizados -->
              <div class="mt-6 border-t border-gray-200 pt-4">
                <div class="flex items-center justify-between mb-3">
                  <span class="text-xs font-semibold text-gray-700 uppercase tracking-wider">Metadatos personalizados</span>
                  <button 
                    (click)="addCreateMetadata()" 
                    type="button" 
                    class="inline-flex items-center text-xs font-medium text-orange-600 hover:text-orange-700">
                    <svg class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                    </svg>
                    Añadir metadato
                  </button>
                </div>
                
                <div *ngIf="newCollection_metadata.length === 0" class="text-xs text-gray-400 italic py-1">
                  Sin metadatos adicionales definidos.
                </div>

                <div *ngFor="let item of newCollection_metadata; let i = index" class="flex items-center gap-2 mb-2">
                  <input 
                    type="text" 
                    [(ngModel)]="item.key" 
                    placeholder="Clave (ej. description)" 
                    class="block w-1/2 rounded-md bg-white px-2.5 py-1.5 text-xs text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:outline-orange-600">
                  <input 
                    type="text" 
                    [(ngModel)]="item.value" 
                    placeholder="Valor" 
                    class="block w-1/2 rounded-md bg-white px-2.5 py-1.5 text-xs text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:outline-orange-600">
                  <button 
                    (click)="removeCreateMetadata(i)" 
                    type="button" 
                    class="text-gray-400 hover:text-red-500 p-1" 
                    title="Eliminar fila">
                    <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </div>
              
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button (click)="createCollection()" type="button" class="inline-flex w-full justify-center rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto">Guardar</button>
                <button (click)="create_modal = !create_modal" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
</section>

<!-- Search modal -->
<section>
    <div *ngIf="search_modal.visible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <!--
          Background backdrop, show/hide based on modal state.
      
          Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>
      
        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <!--
              Modal panel, show/hide based on modal state.
      
              Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                To: "opacity-100 translate-y-0 sm:scale-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 sm:scale-100"
                To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            -->
            <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
              <div class="sm:flex sm:items-start">
                <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                  <svg class="size-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                  </svg>
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold text-gray-900" id="modal-title"></h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">{{search_modal.title}}</p>
                  </div>
                </div>
              </div>
              <div class="relative mt-12">
                <label for="name" class="inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Frase</label>
                <input autofocus (keyup.enter)="searchCollection(search_modal.collection,search_modal.query,search_modal.limit)" type="text" name="query" id="query" [(ngModel)]="search_modal.query" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="Frase a buscar">
                <label for="limit" class="mt-5 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Resultados</label>
                <input type="number" name="limit" id="limit" [(ngModel)]="search_modal.limit" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="">
              </div>
              
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button (click)="searchCollection(search_modal.collection,search_modal.query,search_modal.limit)" type="button" class="inline-flex w-full justify-center rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto">Buscar</button>
                <button (click)="search_modal.visible = !search_modal.visible" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
</section>

<section class="relative z-20">
    <div *ngIf="banner.bool" aria-live="assertive" class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6">
        <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
        <!--
            Notification panel, dynamically insert this into the live region when it needs to be displayed
    
            Entering: "transform ease-out duration-300 transition"
            From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            To: "translate-y-0 opacity-100 sm:translate-x-0"
            Leaving: "transition ease-in duration-100"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5">
            <div class="p-4">
            <div class="flex items-start">
                <div class="shrink-0">
                <svg class='size-6 {{banner.color ? "text-green-500" : "text-red-500"}}' fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
                </div>
                <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-900">{{banner.title}}</p>
                <p class="mt-1 text-sm text-gray-500">{{banner.text}}</p>
                </div>
                <div class="ml-4 flex shrink-0">
                <button (click)="closeBanner()" type="button" class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                    <span class="sr-only">Close</span>
                    <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                    <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                    </svg>
                </button>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>

    <div *ngIf="showWarningModal" class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity backdrop-blur-sm"></div>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          
          <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            
            <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start">
                
                <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10">
                  <svg class="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                  </svg>
                </div>

                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">
                    ¿Iniciar Análisis de Topics?
                  </h3>
                  <div class="mt-2">
                    <p *ngIf="hasActiveTopicFilter" class="text-sm text-gray-600">
                      Se analizarán las <strong class="text-indigo-600 font-semibold">{{ targetTopicsCollections.length }}</strong> colecciones resultantes del filtro y límite activo en la lista.
                    </p>
                    <p *ngIf="!hasActiveTopicFilter" class="text-sm text-gray-600">
                      Esta operación escaneará <strong class="text-gray-900 font-semibold">todas las colecciones</strong> ({{ allCollections.length }}) y documentos de la base de datos.
                    </p>
                    <p class="mt-2 text-xs text-gray-500">
                      <strong>Nota:</strong> Puede tardar varios segundos y aumentar temporalmente la carga del servidor (CPU/Memoria).
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="gap-2 bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button 
                type="button" 
                (click)="confirmNavigation()"
                class="inline-flex bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition duration-150 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 text-sm font-medium">
                Continuar y Analizar
              </button>
              <button 
                type="button" 
                (click)="cancelNavigation()"
                class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto transition-colors">
                Cancelar
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
</section>
  
    
  